import React from "react";


const Blog = () => (
  <div className="menucontent mx-auto post-wrap">
    <h1>ini Halaman Blog </h1>
  </div>
)

export default Blog; 